import { render, staticRenderFns } from "./facebook-sv3-speed.vue?vue&type=template&id=42673bb3&scoped=true&"
import script from "./facebook-sv3-speed.vue?vue&type=script&lang=js&"
export * from "./facebook-sv3-speed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42673bb3",
  null
  
)

export default component.exports